export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const CLEAR_LOADING_MESSAGE = 'CLEAR_LOADING_MESSAGE';
